import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";


function OrbisAdminUXStyle() {
    return (
        <style>{`
            .orbis-admin-page{
                min-height:100vh;
                background:#041426;
                color:#f5fbff;
                padding:24px;
            }
            .orbis-admin-page .page-container,
            .orbis-admin-page.page-container{
                max-width:1500px;
                margin:0 auto;
            }
            .orbis-admin-page .page-header{
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);
                border:1px solid rgba(11,93,140,.8);
                box-shadow:0 20px 45px rgba(0,0,0,.28);
                border-radius:28px;
                padding:28px;
                margin-bottom:24px;
            }
            .orbis-admin-page .page-title{
                font-size:36px;
                line-height:1.05;
                font-weight:900;
                color:#fff!important;
                margin:0;
                letter-spacing:-.03em;
            }
            .orbis-admin-page .page-subtitle{
                margin-top:12px;
                color:#d7e8f6!important;
                font-size:14px;
                line-height:1.65;
                max-width:860px;
            }
            .orbis-admin-page .card{
                border:1px solid rgba(11,93,140,.82)!important;
                background:#04192b!important;
                color:#f5fbff!important;
                box-shadow:0 12px 30px rgba(0,0,0,.24)!important;
            }
            .orbis-admin-page .card-header-inline{
                background:#031425!important;
                border-bottom:1px solid #0b4d78!important;
            }
            .orbis-admin-page .card-title,
            .orbis-admin-page h1,
            .orbis-admin-page h2,
            .orbis-admin-page h3{
                color:#fff!important;
            }
            .orbis-admin-page p,
            .orbis-admin-page .text-gray-500,
            .orbis-admin-page .text-gray-600{
                color:#9fc4df!important;
            }
            .orbis-admin-page label{
                color:#8fb9da!important;
                font-weight:700;
            }
            .orbis-admin-page input,
            .orbis-admin-page select,
            .orbis-admin-page textarea{
                background:#0b2740!important;
                color:#fff!important;
                border-color:#0b5f91!important;
            }
            .orbis-admin-page input::placeholder,
            .orbis-admin-page textarea::placeholder{
                color:#7ea8c7!important;
            }
            .orbis-admin-page input:focus,
            .orbis-admin-page select:focus,
            .orbis-admin-page textarea:focus{
                border-color:#d4af37!important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18)!important;
                outline:none!important;
            }
            .orbis-admin-page select option{
                background:#061a2f;
                color:#fff;
            }
            .orbis-admin-page .btn{
                border-color:#24537a!important;
                border-radius:999px!important;
                font-weight:700!important;
            }
            .orbis-admin-page .btn-secondary{
                background:#0b2740!important;
                color:#f5fbff!important;
            }
            .orbis-admin-page .btn-secondary:hover{
                background:#10324f!important;
                border-color:#d4af37!important;
            }
            .orbis-admin-page .btn-primary{
                background:#d4af37!important;
                color:#081a2b!important;
                border-color:#d4af37!important;
                font-weight:800!important;
            }
            .orbis-admin-page table{
                border-collapse:separate;
                border-spacing:0;
                background:#061a2f!important;
            }
            .orbis-admin-page table thead th{
                position:sticky;
                top:0;
                z-index:10;
                background:#061a2f!important;
                color:#8fb9da!important;
                border-bottom:1px solid #24587c!important;
                text-transform:uppercase;
                letter-spacing:.13em;
            }
            .orbis-admin-page table tbody tr{
                transition:background .18s ease, box-shadow .18s ease;
                background:#08233d!important;
            }
            .orbis-admin-page table tbody tr:nth-child(even){
                background:#092a49!important;
            }
            .orbis-admin-page table tbody tr:hover{
                background:rgba(56,189,248,.075)!important;
                box-shadow:inset 3px 0 0 #d4af37;
            }
            .orbis-admin-page table tbody td{
                border-top:1px solid #24587c!important;
                color:#f5fbff!important;
                background:transparent!important;
            }
            .orbis-admin-page .scroll-shell{
                background:#04192b!important;
                border-color:#24587c!important;
            }
            .orbis-admin-page .top-scroll{
                background:#061a2f!important;
                border-bottom-color:#24587c!important;
            }
            .orbis-admin-page .avatar,
            .orbis-admin-page .avatar-fallback{
                border-color:#0b5f91!important;
                background:#0b2740!important;
                color:#d9f4ff!important;
            }
            .orbis-admin-page ::-webkit-scrollbar{height:10px;width:10px}
            .orbis-admin-page ::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .orbis-admin-page ::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .orbis-admin-page ::-webkit-scrollbar-thumb:hover{background:#d4af37}
        `}</style>
    );
}

function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table {
                border-collapse: separate !important;
                border-spacing: 0 !important;
                background: #061a2f !important;
            }

            .grid-rows-pro table thead th {
                position: sticky;
                top: 0;
                z-index: 10;
                background: #061a2f !important;
                color: #8fb9da !important;
                border-bottom: 1px solid #24587c !important;
                text-transform: uppercase;
                letter-spacing: .13em;
            }

            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease, box-shadow 0.18s ease;
                background: #08233d !important;
            }

            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro table tbody tr:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37 !important;
            }

            .grid-rows-pro table tbody tr:hover td,
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #f5fbff !important;
                vertical-align: top;
                border-top: 1px solid #24587c !important;
                background: transparent !important;
            }

            .grid-rows-pro .scroll-shell {
                border: 1px solid #24587c !important;
                border-radius: 18px;
                background: #04192b !important;
                overflow: hidden;
            }

            .grid-rows-pro .top-scroll,
            .grid-rows-pro .bottom-scroll {
                overflow-x: auto;
                overflow-y: hidden;
                background: #061a2f !important;
            }

            .grid-rows-pro .top-scroll {
                height: 16px;
                border-bottom: 1px solid #24587c !important;
            }

            .grid-rows-pro .avatar {
                width: 38px;
                height: 38px;
                border-radius: 999px;
                object-fit: cover;
                border: 1px solid #0b5f91 !important;
                background: #0b2740 !important;
            }

            .grid-rows-pro .avatar-fallback {
                width: 38px;
                height: 38px;
                border-radius: 999px;
                display: grid;
                place-items: center;
                background: #0b2740 !important;
                border: 1px solid #0b5f91 !important;
                color: #d9f4ff !important;
                font-weight: 800;
                font-size: 12px;
            }

            .users-page-pro,
            .users-page-pro * {
                box-sizing: border-box;
            }

            .users-page-pro {
                background:#041426 !important;
                color:#f5fbff !important;
            }

            .users-page-pro .page-header {
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%) !important;
                border:1px solid rgba(11,93,140,.8) !important;
                box-shadow:0 20px 45px rgba(0,0,0,.28) !important;
                border-radius:28px !important;
                padding:28px !important;
                margin-bottom:24px !important;
            }

            .users-page-pro .page-title {
                font-size:36px !important;
                line-height:1.05 !important;
                font-weight:900 !important;
                color:#fff !important;
                margin:0 !important;
                letter-spacing:-.03em !important;
            }

            .users-page-pro .page-subtitle {
                margin-top:12px !important;
                color:#d7e8f6 !important;
                font-size:14px !important;
                line-height:1.65 !important;
                max-width:860px !important;
            }

            .users-page-pro .card {
                border:1px solid rgba(11,93,140,.82) !important;
                background:#04192b !important;
                color:#f5fbff !important;
                box-shadow:0 12px 30px rgba(0,0,0,.24) !important;
                border-radius:24px !important;
            }

            .users-page-pro .card-header-inline {
                background:#031425 !important;
                border-bottom:1px solid #0b4d78 !important;
                padding:16px 20px !important;
            }

            .users-page-pro .card-title {
                color:#d4af37 !important;
                text-transform:uppercase !important;
                letter-spacing:.18em !important;
                font-size:11px !important;
                font-weight:800 !important;
            }

            .users-page-pro .form-grid {
                padding:20px !important;
            }

            .users-page-pro .form-field label {
                color:#8fb9da !important;
                font-weight:800 !important;
                text-transform:uppercase !important;
                letter-spacing:.12em !important;
                font-size:11px !important;
            }

            .users-page-pro input,
            .users-page-pro select,
            .users-page-pro textarea {
                background:#0b2740 !important;
                color:#fff !important;
                border:1px solid #0b5f91 !important;
                border-radius:12px !important;
                padding:9px 11px !important;
            }

            .users-page-pro input::placeholder,
            .users-page-pro textarea::placeholder {
                color:#7ea8c7 !important;
            }

            .users-page-pro input:focus,
            .users-page-pro select:focus,
            .users-page-pro textarea:focus {
                border-color:#d4af37 !important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18) !important;
                outline:none !important;
            }

            .users-page-pro select option {
                background:#061a2f !important;
                color:#fff !important;
            }

            .users-page-pro .btn,
            .users-page-pro button {
                border-radius:999px !important;
                font-weight:700 !important;
            }

            .users-page-pro .btn-secondary,
            .users-page-pro button:not(.btn-primary):not(.unstyled) {
                background:#0b2740 !important;
                border:1px solid #24537a !important;
                color:#f5fbff !important;
            }

            .users-page-pro .btn-secondary:hover,
            .users-page-pro button:not(.btn-primary):not(.unstyled):hover {
                background:#10324f !important;
                border-color:#d4af37 !important;
            }

            .users-page-pro .btn-primary,
            .users-page-pro .bg-cani-primary {
                background:#d4af37 !important;
                border-color:#d4af37 !important;
                color:#081a2b !important;
            }

            .users-page-pro [style*="color: #111827"],
            .users-page-pro [style*="color:#111827"],
            .users-page-pro [style*="color: rgb(17, 24, 39)"] {
                color:#f5fbff !important;
            }

            .users-page-pro [style*="color: #6b7280"],
            .users-page-pro [style*="color:#6b7280"],
            .users-page-pro [style*="color: #666"],
            .users-page-pro [style*="color:#666"] {
                color:#9fc4df !important;
            }

            .users-page-pro [style*="color: #15803d"],
            .users-page-pro [style*="color:#15803d"] {
                color:#7cebd0 !important;
            }

            .users-page-pro ::-webkit-scrollbar{height:10px;width:10px}
            .users-page-pro ::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .users-page-pro ::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .users-page-pro ::-webkit-scrollbar-thumb:hover{background:#d4af37}
        `}</style>
    );
}

function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return { ...extra, Authorization: `Bearer ${token}`, "X-CANI-AUTH": token };
}

async function safeJson(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    let data = null;

    try { data = text ? JSON.parse(text) : null; }
    catch { throw new Error(`Respuesta no JSON HTTP ${res.status}: ${text.slice(0, 180)}`); }

    if (!res.ok || !data?.ok) throw new Error(data?.error || data?.detail || `HTTP ${res.status}`);

    return data;
}

function readPermissions() {
    try { return JSON.parse(localStorage.getItem("cani_permissions") || "[]"); }
    catch { return []; }
}

function isAdminRole(role) {
    const r = String(role || "").toLowerCase();
    return r === "admin" || r === "administrador";
}

function canOpenUsersPage() {
    const role = localStorage.getItem("role") || "";
    const perms = readPermissions();
    return isAdminRole(role) || perms.includes("users.view") || perms.includes("users.manage") || perms.includes("permissions.manage");
}

function genPassword(len = 12) {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%";
    let out = "";
    for (let i = 0; i < len; i++) out += chars[Math.floor(Math.random() * chars.length)];
    return out;
}

function initials(name = "", fallback = "") {
    const base = String(fallback || name || "U").trim();
    const parts = base.split(/\s+/).filter(Boolean);
    return parts.slice(0, 2).map((p) => p[0]).join("").toUpperCase() || "U";
}

function avatarUrl(path) {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    return `${window.location.origin}${path.startsWith("/") ? "" : "/"}${path}`;
}

function formatHumanDate(value, fallback = "—") {
    if (!value) return fallback;
    const normalized = String(value).replace(" ", "T");
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) return String(value);

    const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    const dd = String(d.getDate()).padStart(2, "0");
    const mmm = months[d.getMonth()];
    const yyyy = d.getFullYear();

    return `${dd}-${mmm}-${yyyy}`;
}

function Modal({ open, title, onClose, children }) {
    if (!open) return null;
    return (
        <>
            <div style={{ position: "fixed", inset: 0, background: "rgba(2,6,23,0.45)", zIndex: 2000 }} onClick={onClose} />
            <div style={{ position: "fixed", inset: 0, zIndex: 2100, display: "grid", placeItems: "center", padding: 16 }}>
                <div className="card" style={{ width: "min(1080px, 96vw)", maxHeight: "90vh", overflow: "auto" }}>
                    <div className="card-header-inline" style={{ alignItems: "center" }}>
                        <h3 className="card-title" style={{ margin: 0 }}>{title}</h3>
                        <button className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                    <div style={{ paddingTop: 12 }}>{children}</div>
                </div>
            </div>
        </>
    );
}

function DoubleScrollTable({ minWidth = 1180, children }) {
    const topRef = useRef(null);
    const bottomRef = useRef(null);
    const syncing = useRef(false);

    const sync = (from) => {
        if (syncing.current) return;
        syncing.current = true;

        if (from === "top" && topRef.current && bottomRef.current) bottomRef.current.scrollLeft = topRef.current.scrollLeft;
        if (from === "bottom" && topRef.current && bottomRef.current) topRef.current.scrollLeft = bottomRef.current.scrollLeft;

        requestAnimationFrame(() => { syncing.current = false; });
    };

    return (
        <div className="scroll-shell">
            <div className="top-scroll" ref={topRef} onScroll={() => sync("top")}>
                <div style={{ width: minWidth, height: 1 }} />
            </div>
            <div className="bottom-scroll" ref={bottomRef} onScroll={() => sync("bottom")}>
                <div style={{ minWidth }}>{children}</div>
            </div>
        </div>
    );
}

const ROLE_OPTIONS = [
    ["admin", "admin"],
    ["pm", "pm"],
    ["afiliaciones", "afiliaciones"],
    ["solo_lectura", "solo_lectura"],
    ["sponsor", "sponsor"],
    ["reviewer", "reviewer"],
    ["responsible", "responsible"],
    ["stakeholder", "stakeholder"],
];

export default function UsersPage() {
    const navigate = useNavigate();
    const canOpen = canOpenUsersPage();

    const [users, setUsers] = useState([]);
    const [q, setQ] = useState("");
    const [toast, setToast] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(null);
    const [avatarFile, setAvatarFile] = useState(null);

    const [draft, setDraft] = useState({
        display_name: "",
        email: "",
        role: "pm",
        password: "",
        is_active: 1,
        phone: "",
        position: "",
        job_title: "",
        iniciales: "",
        avatar_path: "",
    });

    const filtered = useMemo(() => {
        const s = q.trim().toLowerCase();
        if (!s) return users;
        return users.filter((u) =>
            (u.display_name || "").toLowerCase().includes(s) ||
            (u.email || "").toLowerCase().includes(s) ||
            (u.role || "").toLowerCase().includes(s) ||
            (u.phone || "").toLowerCase().includes(s) ||
            (u.position || "").toLowerCase().includes(s) ||
            (u.session?.status || "").toLowerCase().includes(s)
        );
    }, [users, q]);

    async function loadUsers() {
        setLoading(true);
        try {
            const data = await safeJson(`${API_BASE}/users_list.php`, { headers: authHeaders() });
            const rawUsers = data.users || [];

            let sessionMap = {};
            try {
                const sessionsData = await safeJson(`${API_BASE}/user_sessions_list.php`, { headers: authHeaders() });
                sessionMap = sessionsData.session_map || {};
            } catch {
                sessionMap = {};
            }

            setUsers(rawUsers.map((u) => ({
                ...u,
                session: sessionMap[String(u.id)] || null,
            })));
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { loadUsers(); }, []);

    function closeModal() {
        setModal(null);
        setAvatarFile(null);
    }

    function openNew() {
        setDraft({ display_name: "", email: "", role: "pm", password: "", is_active: 1, phone: "", position: "", job_title: "", iniciales: "", avatar_path: "" });
        setAvatarFile(null);
        setModal("new");
    }

    function openEdit(u) {
        setDraft({
            id: u.id,
            display_name: u.display_name || "",
            email: u.email || "",
            role: u.role || "pm",
            password: "",
            is_active: Number(u.is_active ?? 1),
            phone: u.phone || "",
            position: u.position || u.job_title || "",
            job_title: u.job_title || u.position || "",
            iniciales: u.iniciales || "",
            avatar_path: u.avatar_path || "",
        });
        setAvatarFile(null);
        setModal("edit");
    }

    async function uploadAvatarIfNeeded(userId) {
        if (!avatarFile || !userId) return null;

        const fd = new FormData();
        fd.append("file", avatarFile);
        fd.append("user_id", String(userId));

        const data = await safeJson(`${API_BASE}/user_avatar_upload.php`, {
            method: "POST",
            headers: authHeaders(),
            body: fd,
        });

        return data.path || null;
    }

    async function createUser() {
        const payload = {
            display_name: draft.display_name.trim(),
            email: draft.email.trim(),
            role: draft.role,
            password: draft.password,
            phone: draft.phone,
            position: draft.position,
            job_title: draft.job_title || draft.position,
            iniciales: draft.iniciales,
        };

        const data = await safeJson(`${API_BASE}/user_create.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });

        if (avatarFile && data.id) await uploadAvatarIfNeeded(data.id);

        setToast({ type: "ok", msg: "Usuario creado" });
        closeModal();
        await loadUsers();
    }

    async function updateUser() {
        const payload = {
            id: draft.id,
            display_name: draft.display_name.trim(),
            email: draft.email.trim(),
            role: draft.role,
            is_active: draft.is_active,
            phone: draft.phone,
            position: draft.position,
            job_title: draft.job_title || draft.position,
            iniciales: draft.iniciales,
            avatar_path: draft.avatar_path,
        };

        if (draft.password?.trim()) payload.password = draft.password;

        await safeJson(`${API_BASE}/user_update.php`, {
            method: "POST",
            headers: authHeaders({ "Content-Type": "application/json" }),
            body: JSON.stringify(payload),
        });

        if (avatarFile && draft.id) await uploadAvatarIfNeeded(draft.id);

        setToast({ type: "ok", msg: "Usuario actualizado" });
        closeModal();
        await loadUsers();
    }

    async function releaseSession(user) {
        if (!user?.id) return;
        if (!window.confirm(`¿Liberar sesión activa de ${user.display_name || user.email}?`)) return;

        try {
            await safeJson(`${API_BASE}/user_session_release.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ user_id: Number(user.id) }),
            });

            setToast({ type: "ok", msg: "Sesión liberada correctamente." });
            await loadUsers();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    function goPermissions(userId) {
        navigate(`/permissions?user_id=${userId}`);
    }

    if (!canOpen) {
        return (
            <MainLayout>
                <OrbisAdminUXStyle />
                <GridRowsProStyle />
                <div className="users-page-pro orbis-admin-page page-container grid-rows-pro">
                    <div className="card"><div className="alert-info">No autorizado. Esta sección requiere permiso de usuarios.</div></div>
                </div>
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <OrbisAdminUXStyle />
            <GridRowsProStyle />
            <div className="users-page-pro orbis-admin-page page-container grid-rows-pro">
                <div className="page-header">
                    <div>
                        <h1 className="page-title">Usuarios</h1>
                        <p className="page-subtitle">Administración de perfiles, accesos, avatar, teléfono, puesto, rol y estatus.</p>
                    </div>
                    <div className="page-header-actions">
                        <button className="btn btn-primary" onClick={openNew}>Nuevo usuario</button>
                        <button className="btn btn-secondary" onClick={loadUsers}>Recargar</button>
                    </div>
                </div>

                <div className="card">
                    <div className="form-grid">
                        <div className="form-field full-width">
                            <label>Buscar</label>
                            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nombre, correo, rol, teléfono o puesto..." />
                        </div>
                    </div>

                    {loading ? (
                        <div>Cargando…</div>
                    ) : (
                        <DoubleScrollTable minWidth={1460}>
                            <table className="table" style={{ width: "100%", minWidth: 1460 }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 280 }}>Usuario</th>
                                        <th style={{ width: 260 }}>Correo</th>
                                        <th style={{ width: 140 }}>Teléfono</th>
                                        <th style={{ width: 180 }}>Puesto</th>
                                        <th style={{ width: 120 }}>Rol</th>
                                        <th style={{ width: 110 }}>Estatus</th>
                                        <th style={{ width: 150 }}>Creado</th>
                                        <th style={{ width: 210 }}>Sesión</th>
                                        <th style={{ width: 270 }}>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtered.map((u) => (
                                        <tr key={u.id}>
                                            <td>
                                                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                                    {u.avatar_path ? <img className="avatar" src={avatarUrl(u.avatar_path)} alt="" /> : <div className="avatar-fallback">{initials(u.display_name, u.iniciales)}</div>}
                                                    <div>
                                                        <strong>{u.display_name}</strong>
                                                        <div style={{ fontSize: 12, color: "#6b7280" }}>ID {u.id} · {u.iniciales || "Sin iniciales"}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{u.email}</td>
                                            <td>{u.phone || "—"}</td>
                                            <td>{u.position || u.job_title || "—"}</td>
                                            <td>{u.role}</td>
                                            <td>{Number(u.is_active) === 1 ? "Activo" : "Inactivo"}</td>
                                            <td>{formatHumanDate(u.created_at)}</td>
                                            <td>
                                                {u.session?.active ? (
                                                    <div>
                                                        <div style={{ fontWeight: 700, color: "#15803d" }}>Logueado</div>
                                                        <div style={{ fontSize: 12, color: "#6b7280" }}>Expira: {formatHumanDate(u.session.expires_at)}</div>
                                                    </div>
                                                ) : (
                                                    <span style={{ color: "#6b7280" }}>Sin sesión</span>
                                                )}
                                            </td>
                                            <td>
                                                <div className="form-actions">
                                                    <button className="btn btn-secondary btn-small" onClick={() => openEdit(u)}>Editar</button>
                                                    <button className="btn btn-secondary btn-small" onClick={() => goPermissions(u.id)}>Permisos</button>
                                                    <button className="btn btn-secondary btn-small" onClick={() => releaseSession(u)}>Liberar sesión</button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {filtered.length === 0 ? <tr><td colSpan={9} style={{ color: "#6b7280" }}>Sin resultados.</td></tr> : null}
                                </tbody>
                            </table>
                        </DoubleScrollTable>
                    )}
                </div>

                <Modal open={modal === "new" || modal === "edit"} title={modal === "new" ? "Nuevo usuario" : "Editar usuario"} onClose={closeModal}>
                    <div className="form-grid">
                        <div className="form-field">
                            <label>Nombre</label>
                            <input value={draft.display_name} onChange={(e) => setDraft({ ...draft, display_name: e.target.value })} />
                        </div>
                        <div className="form-field">
                            <label>Correo</label>
                            <input value={draft.email} onChange={(e) => setDraft({ ...draft, email: e.target.value })} />
                        </div>
                        <div className="form-field">
                            <label>Teléfono</label>
                            <input value={draft.phone} onChange={(e) => setDraft({ ...draft, phone: e.target.value })} />
                        </div>
                        <div className="form-field">
                            <label>Puesto / cargo</label>
                            <input value={draft.position} onChange={(e) => setDraft({ ...draft, position: e.target.value, job_title: e.target.value })} />
                        </div>
                        <div className="form-field">
                            <label>Iniciales</label>
                            <input value={draft.iniciales} onChange={(e) => setDraft({ ...draft, iniciales: e.target.value.toUpperCase() })} />
                        </div>
                        <div className="form-field">
                            <label>Rol</label>
                            <select value={draft.role} onChange={(e) => setDraft({ ...draft, role: e.target.value })}>
                                {ROLE_OPTIONS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                            </select>
                        </div>
                        <div className="form-field">
                            <label>Estatus</label>
                            <select value={draft.is_active} onChange={(e) => setDraft({ ...draft, is_active: Number(e.target.value) })}>
                                <option value={1}>Activo</option>
                                <option value={0}>Inactivo</option>
                            </select>
                        </div>
                        <div className="form-field">
                            <label>{modal === "new" ? "Contraseña" : "Reset contraseña (opcional)"}</label>
                            <input type="password" value={draft.password} onChange={(e) => setDraft({ ...draft, password: e.target.value })} />
                            <div className="form-actions" style={{ marginTop: 6 }}>
                                <button type="button" className="btn btn-secondary btn-small" onClick={() => setDraft({ ...draft, password: genPassword() })}>Generar</button>
                            </div>
                        </div>
                        <div className="form-field full-width">
                            <label>Imagen / avatar</label>
                            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                                {draft.avatar_path ? <img className="avatar" src={avatarUrl(draft.avatar_path)} alt="" /> : <div className="avatar-fallback">{initials(draft.display_name, draft.iniciales)}</div>}
                                <input type="file" accept="image/*" onChange={(e) => setAvatarFile(e.target.files?.[0] || null)} />
                            </div>
                            {avatarFile ? <div style={{ fontSize: 12, color: "#6b7280", marginTop: 6 }}>Archivo seleccionado: {avatarFile.name}</div> : null}
                        </div>
                        <div className="form-actions full-width">
                            <button className="btn btn-primary" onClick={async () => { try { if (modal === "new") await createUser(); else await updateUser(); } catch (e) { setToast({ type: "error", msg: e.message }); } }}>Guardar</button>
                            {modal === "edit" && draft.id ? <button type="button" className="btn btn-secondary" onClick={() => goPermissions(draft.id)}>Gestionar permisos</button> : null}
                            <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                        </div>
                    </div>
                </Modal>

                {toast ? (
                    <div className="card" style={{ position: "fixed", right: 16, bottom: 16, maxWidth: 560, zIndex: 3000 }}>
                        <div style={{ fontWeight: 700, marginBottom: 6 }}>{toast.type === "error" ? "Error" : "OK"}</div>
                        <div style={{ color: "#d7e8f6" }}>{toast.msg}</div>
                    </div>
                ) : null}
            </div>
        </MainLayout>
    );
}
